export const emailRule = {
  pattern: {
    value:
      /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i,
    message: "L'email est invalide",
  },
};

export const phoneRule = {
  pattern: {
    value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
    message: "Le numéro est invalide",
  },
};

export const urlRule = {
  pattern: {
    value: /^https:\/\/bit\.ly\/[A-Za-z0-9\-]+$/,
    message: "L'url est invalide",
  },
};

export const passwordRule = {
  pattern: {
    value: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}/,
    message:
      "Doit contenir au moins une lettre minuscule, une majuscule, un chiffre et au moins 8 caractères",
  },
};